import Button from '@shared/components/buttons';
import Modal from '@shared/components/modals';
import { html, nothing } from '@shared/utils/rendering/html';
import AttestationHistoryTable from './attestation-history-table';

const AttestationHistory = ({ recordId, title, closeModal, isVisible }) => {
    return html`
        <${Modal}
            id="attestation-history-modal"
            header=${{
                title: {
                    text: 'Attestation Record History',
                    antecedent: '',
                },
                subtitle: {
                    text: title,
                },
            }}
            footer=${html`<${Button}
                buttonType="primary"
                label=${{ text: 'Close' }}
                onClick=${closeModal}
            />`}
            options=${{
                isVisible,
                onCloseEvent: closeModal,
            }}>
                ${isVisible ? html`<${AttestationHistoryTable} recordId=${recordId} />` : nothing}
        </${Modal} >
    `;
};

export default AttestationHistory;
